import { Graph } from './components/Graph/Graph';

function App() {
    return (
        <div className="app">
            <Graph />
        </div>
    );
}

export default App;
